// @flow
import React from "react";
import type { Node } from "react";
import Link from "../Link";
import Typography from "../Typography";

import styles from "./hrefButton.module.scss";

type Props = {
  children: Node,
  className?: string,
  cypress: string | null,
  href: string,
  onBlur?: (event: SyntheticEvent) => any,
  onClick?: (event: SyntheticEvent) => any,
  onFocus?: (event: SyntheticEvent) => any,
  onKeyDown?: (event: SyntheticEvent) => any,
  tabIndex: number | null,
  type: "primary" | "secondary",
  size: "h1" | "h2" | "h3" | "primary" | "secondary" | "subtext",
  target: null,
  rel: ?string,
  block?: boolean
};

const HrefButton = ({
  className,
  cypress,
  href,
  onBlur,
  onClick,
  onFocus,
  onKeyDown,
  type,
  target,
  rel,
  tabIndex,
  size,
  block,
  children
}: Props) => {
  const typeClass = type === "primary" ? styles.primary : styles.secondary;
  return (
    <Link
      className={`${styles.hrefButton} ${typeClass} ${className} ${
        block && styles.block
      }`}
      href={href}
      target={target}
      rel={rel}
      tabIndex={tabIndex}
      onBlur={onBlur}
      onClick={onClick}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      cypress={cypress}
      size={size}
    >
      {children}
    </Link>
  );
};

HrefButton.defaultProps = {
  className: "",
  cypress: null,
  onBlur: () => {},
  onClick: () => {},
  onFocus: () => {},
  onKeyDown: () => {},
  size: Typography.defaultProps.size,
  tabIndex: null,
  type: "primary",
  target: null,
  rel: "noopener noreferrer",
  block: false
};

export default HrefButton;
